export const trucking = [
  {
    icon: 'fas fa-layer-group',
    title: 'Built for developers',
    subtitle:
      'TheFront is built to make your life easier. Variables, build tooling, documentation, and reusable components.',
  },
  {
    icon: 'fab fa-sketch',
    title: 'Designed to be modern',
    subtitle:
      'Designed with the latest design trends in mind. TheFront feels modern, minimal, and beautiful.',
  },
  {
    icon: 'fas fa-code',
    title: 'Documentation for everything',
    subtitle:
      "We've written extensive documentation for components and tools, so you never have to reverse engineer anything.",
  },
];

export const features = [
  {
    icon: 'far fa-comment',
    title: `Ensuring clear communication`,
    subtitle:
      'We keep you in the loop every step of the way. You can rely on a transparent, comprehensible flow of information.',
  },
  {
    icon: 'far fa-paper-plane',
    title: 'Making the most of technology',
    subtitle:
      'Time is precious. We guarantee a high degree of efficiency and a premium level of service by using the right tools.',
  },
  {
    icon: 'far fa-heart',
    title: 'Providing excellent customer service',
    subtitle:
      'We are passionate about what we do and we take pride in achieving the personalised results that you have in mind.',
  },
];

export const team = [
  'Our sign up is dead simple. We only require your basic company information',
  'We support bulk uploading via SQL, integrations with most data storage products',
  "Simply select where you'd like to transfer your data ",
];

export const integrations = [
  {
    logo: 'https://assets.maccarianagency.com/the-front/logos/slack.svg',
    name: 'Slack',
    title:
      "Sync your team's work and activity to share automatically in a channel with a simple plugin.",
  },
  {
    logo: 'https://assets.maccarianagency.com/the-front/logos/mailchimp.svg',
    name: 'Mailchimp',
    title:
      'Communicate important messages to your users through TheFront using Mailchimp as the delivery service.',
  },
  {
    logo: 'https://assets.maccarianagency.com/the-front/logos/dropbox.svg',
    name: 'Dropbox',
    title:
      'Sync any file store to Dropbox for automated sharing with people outside the company.',
  },
];

export const reviews = [
  {
    authorPhoto: {
      src: 'https://assets.maccarianagency.com/the-front/photos/people/veronica-adams.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/veronica-adams@2x.jpg 2x',
    },
    authorName: 'Veronica Adams',
    authorOccupation: 'Growth Marketer, Crealytics',
    feedback:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    authorPhoto: {
      src: 'https://assets.maccarianagency.com/the-front/photos/people/akachi-luccini.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/akachi-luccini@2x.jpg 2x',
    },
    authorName: 'Akachi Luccini',
    authorOccupation: 'Lead Generation, Alternative Capital',
    feedback:
      'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
  },
];

export const jobs = [
  {
    title: 'Front-End Developer',
    location: 'Madrid',
    type: 'Remote',
  },
  {
    title: 'Community Manager',
    location: 'Paris',
    type: 'Full time',
  },
  {
    title: 'UX/UI Designer',
    location: 'Yerevan',
    type: 'Part time',
  },
];

export const news = [
  {
    cover: {
      src: 'https://assets.maccarianagency.com/the-front/photos/logistics/news1.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/logistics/news1@2x.jpg 2x',
    },
    tag: 'delivery',
    title: 'Optimize the schedules of thousands of trains in minutes.',
    date: '12 June, 2020',
  },
  {
    cover: {
      src: 'https://assets.maccarianagency.com/the-front/photos/logistics/news2.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/logistics/news2@2x.jpg 2x',
    },
    tag: 'Main stream',
    title: 'Optimize the schedules of thousands of trains in minutes.',
    date: '12 June, 2020',
  },
  {
    cover: {
      src: 'https://assets.maccarianagency.com/the-front/photos/logistics/news3.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/logistics/news3@2x.jpg 2x',
    },
    tag: 'Trucks',
    title: 'Optimize the schedules of thousands of trains in minutes.',
    date: '12 June, 2020',
  },
];

export const pricings = [
  {
    title: 'Standard License',
    subtitle: 'A pay-once license, just for you',
    price: '$49',
    priceSuffix: ' / MO',
    features: [
      'Rich, responsive landing pages',
      '100+ styled components',
      'Flexible, simple license',
      'Speedy build tooling',
      '6 months free support included',
    ],
    disclaimer: 'Fully featured 30-day free trial',
    isHighlighted: false,
  },
  {
    title: 'Extended License',
    subtitle: 'A pay-once license, just for you',
    price: '$79',
    priceSuffix: ' / MO',
    features: [
      'Rich, responsive landing pages',
      '100+ styled components',
      'Flexible, simple license',
      'Speedy build tooling',
      '6 months free support included',
    ],
    disclaimer: 'Fully featured 30-day free trial',
    isHighlighted: true,
  },
  {
    title: 'Standard License',
    subtitle: 'A pay-once license, just for you',
    price: '$49',
    priceSuffix: ' / MO',
    features: [
      'Rich, responsive landing pages',
      '100+ styled components',
      'Flexible, simple license',
      'Speedy build tooling',
      '6 months free support included',
    ],
    disclaimer: 'Fully featured 30-day free trial',
    isHighlighted: false,
  },
];
